import { Stack, useTheme } from "@mui/material";
import { Button } from "components";

export const SignatureTabFooter = ({
  onCancel,
  onSave,
  isLoading,
}: {
  onCancel: () => void;
  onSave: () => void;
  isLoading: boolean;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      sx={{
        position: "absolute",
        bgcolor: theme.palette.darkBg.main,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        width: "100%",
        height: "48px",
        justifyContent: "end",
        alignItems: "center",
        gap: "16px",
        px: "24px",
        py: "8px",
        boxShadow:
          "0px -4px 8px 0px #00000005, 0px -14px 14px 0px #00000005, 0px -32px 19px 0px #00000003, 0px -56px 22px 0px #00000000, 0px -88px 25px 0px #00000000",
      }}
    >
      {/* <Button variant="secondary" size="small" disabled={isLoading}>
        Cancel
      </Button> */}
      <Button
        variant="primary"
        size="small"
        loading={isLoading}
        onClick={onSave}
      >
        Save
      </Button>
    </Stack>
  );
};
